import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFunnelStyle0 = cosmosIconCss;

const CosmosIconFunnel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFunnel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '466402667b005aa3016ba3fd9a04ed06e57ef0eb', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '58e70c103d7f40a3a3e10ef408fd74c21327c643', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a991a34c3a64fb2354a491ebc244ba0bd0faea47', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.5 18.96a.5.5 0 0 0 .812.39l4-3.2a.5.5 0 0 0 .188-.39V11l4.372-4.857A.5.5 0 0 0 18 5.808V3.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v2.308a.5.5 0 0 0 .128.335L8.5 11v7.96Zm8-14.46v.924l-4.5 5v4.855l-2 1.6v-6.455l-4.5-5V4.5h11Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFunnelStyle0; }
}, [1, "cosmos-icon-funnel", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-funnel"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-funnel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFunnel$1);
            }
            break;
    } });
}

const CosmosIconFunnel = CosmosIconFunnel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFunnel, defineCustomElement };
